import { Modal } from "@mui/material";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CtaComponent from "../../../components/reusable-ui/cta";
import {
  BUSINESS_DAYS_NAME_MAP,
  CTA_SIZE,
  CTA_TYPE,
} from "../../../data/constants";
import { AGGREGATOR_FEATURES_MAP } from "../../../data/outlet-status-constants";
import { convertArrayToObject } from "../../../helpers/catalog-helper";
import { isMobileDevice } from "../../../helpers/device-info-helper";
import {
  getDeliveryTimings,
  getSelfDeliveryTimings,
  updateDeliveryTimings,
  updateSelfDeliveryTimings,
} from "../../../redux/slices";
import { TimelineManagementModal } from "../../catalog-management";
import "./style.scss";

interface Props {
  onModalClose: any;
  moreOptionsMenuData: any;
  setApiStateModalData: any;
}

const DeliveryTimings = (props: Props) => {
  const { onModalClose, moreOptionsMenuData, setApiStateModalData } = props;
  const { outletData } = moreOptionsMenuData;
  const [isChangesMade, setIsChangesMade] = useState<boolean>(false);
  const [deliveryTimeSlots, setDeliveryTimeSlots] = useState<any>([]);
  const [apiErrorMsg, setApiErrorMsg] = useState<any>({
    show: false,
    message: null,
  });
  const [timeSlotEditModalData, setTimeSlotEditModalData] = useState<any>({
    show: false,
    day: "",
    slots: [],
    isEditMode: false,
  });

  const dispatch = useDispatch();

  useEffect(() => {
    let dataToPost = {
      brid: outletData?.brid,
      outletId: outletData?.id,
      type: outletData?.type,
    };
    const callback = (success: boolean, response: any) => {
      if (success) {
        setDeliveryTimeSlots(response);
        setApiErrorMsg({ show: false });
      } else if (response?.message) {
        setApiErrorMsg({
          message: response?.message,
          show: true,
        });
      }
    };
    if (
      moreOptionsMenuData?.selectedOptionId ===
      AGGREGATOR_FEATURES_MAP.delivery_timings.id
    ) {
      dispatch(getDeliveryTimings({ dataToPost, callback }));
    } else if (
      moreOptionsMenuData?.selectedOptionId ===
      AGGREGATOR_FEATURES_MAP.self_delivery_timings.id
    ) {
      dispatch(getSelfDeliveryTimings({ dataToPost, callback }));
    }
  }, []);

  const onSaveCtaClick = () => {
    // if (!data?.reason) {
    //   setErrMsgMap({ reason: "This field is mandatory." });
    //   return;
    // }
    // setErrMsgMap({});
    let dataToPost = {
      brid: outletData?.brid,
      outletId: outletData?.id,
      type: outletData?.type,
      data: {
        businessHours: deliveryTimeSlots,
      },
    };
    const callback = (success: boolean, response: any) => {
      if (success) {
        onModalClose();
        setApiStateModalData({
          show: true,
          modalText: `${
            AGGREGATOR_FEATURES_MAP[moreOptionsMenuData?.selectedOptionId].text
          } Updated Successfully.`,
        });
      } else if (response?.message) {
        setApiErrorMsg({
          message: response?.message,
          show: true,
        });
      }
    };
    if (
      moreOptionsMenuData?.selectedOptionId ===
      AGGREGATOR_FEATURES_MAP.delivery_timings.id
    ) {
      dispatch(updateDeliveryTimings({ dataToPost, callback }));
    } else if (
      moreOptionsMenuData?.selectedOptionId ===
      AGGREGATOR_FEATURES_MAP.self_delivery_timings.id
    ) {
      dispatch(updateSelfDeliveryTimings({ dataToPost, callback }));
    }
  };

  const tConvert = ({ hh, mm }: any, isEndTime: boolean = false) => {
    let hrsNum = Number(hh),
      minsNum = Number(mm);
    if (isEndTime) {
      minsNum = minsNum + 1;
      if (minsNum >= 60) {
        minsNum -= 60;
        hrsNum += 1;
      }
      if (hrsNum >= 24) {
        hrsNum -= 24;
      }
    }

    let suf = "AM";
    if (hrsNum >= 12) {
      suf = "PM";
    }

    if (hrsNum > 12) {
      hrsNum -= 12;
    }

    if (hrsNum === 0) {
      hrsNum = 12;
    }
    return `${hrsNum.toLocaleString("en-US", {
      minimumIntegerDigits: 2,
    })}:${minsNum.toLocaleString("en-US", { minimumIntegerDigits: 2 })} ${suf}`;
  };

  const onTimeSlotEditIconClick = (day: string, slots: any) => {
    setTimeSlotEditModalData({ show: true, isEditMode: true, day, slots });
  };

  const onTimeSlotEditModalClose = () => {
    setTimeSlotEditModalData({ show: false });
  };

  const onTimeSlotEditModalSave = (timeSlots: any, selectedDays: any) => {
    let businessDaysList = cloneDeep(deliveryTimeSlots) || [];
    let businessDaysMap = convertArrayToObject(businessDaysList, "day");

    let dataToUpdate = [];
    for (let businessDay of Object.keys(BUSINESS_DAYS_NAME_MAP)) {
      if (!selectedDays[businessDay] && !businessDaysMap[businessDay]) {
        continue;
      }

      if (!selectedDays[businessDay]) {
        dataToUpdate.push(businessDaysMap[businessDay]);
      } else {
        let businessDayData: any = {
          slots: timeSlots,
          day: BUSINESS_DAYS_NAME_MAP[businessDay].shortName,
        };
        dataToUpdate.push(businessDayData);
      }
    }
    setDeliveryTimeSlots(dataToUpdate);
    onTimeSlotEditModalClose();
  };

  const onTimeSlotDeleteIconClick = (day: string) => {
    let businessDaysList: any = cloneDeep(deliveryTimeSlots) || [];
    let dataToUpdate = businessDaysList.filter(
      (businessDay: any) => day !== businessDay?.day
    );
    setDeliveryTimeSlots(dataToUpdate);
  };

  function renderJsonErrorMessage(jsonMsg: any) {
    return (
      <div
        className={`json-error-msg max-h-[516px] pb-[16px] px-[24px] mt-[28px]
      overflow-y-auto whitespace-pre-wrap text-14 sm:px-[16px] sm:mt-[12px]
    `}
      >
        {jsonMsg ? JSON.stringify(jsonMsg, null, 2) : null}
      </div>
    );
  }

  function renderActionFooter() {
    return (
      <div
        className={`absolute bottom-[0px] w-full z-1 right-0 bg-white h-[70px]
          px-24 flex justify-end border-t border-[#EBEBEB] items-center overflow-hidden
          sm:w-full sm:px-[16px]
        `}
      >
        <CtaComponent
          ctaText={"Discard"}
          ctaType={CTA_TYPE.secondary_cta}
          ctaSize={isMobileDevice() ? CTA_SIZE.small : CTA_SIZE.medium}
          onCtaClick={onModalClose}
          customClass={"mr-10 sm:mr-[8px]"}
        ></CtaComponent>
        <CtaComponent
          ctaText={"Save"}
          ctaType={CTA_TYPE.active_cta}
          ctaSize={isMobileDevice() ? CTA_SIZE.small : CTA_SIZE.medium}
          onCtaClick={onSaveCtaClick}
          customClass={"ml-10 sm:ml-[8px]"}
          isDisabled={!isChangesMade}
        ></CtaComponent>
      </div>
    );
  }

  function renderModalHeader() {
    return (
      <div
        className={`flex items-center justify-between py-[12px] px-[24px] border-b border-black/[0.15]
          absolute top-0 w-full sm:px-[16px]
        `}
      >
        <p className="text-22 font-semibold">
          {`${
            AGGREGATOR_FEATURES_MAP[moreOptionsMenuData?.selectedOptionId].text
          } - ${outletData?.channelDefName}`}
        </p>
        <div
          className="rista-sprite ic-cross-black"
          onClick={onModalClose}
        ></div>
      </div>
    );
  }

  function renderDeliveryTimeSlots() {
    return deliveryTimeSlots?.length
      ? deliveryTimeSlots?.map((businessDay: any, index: any) => {
          return businessDay?.slots?.length ? (
            <div
              className="border border-[#EBEBEB] rounded-[8px] mb-[12px] last:mb-0"
              key={`businessDay-item-${index}`}
            >
              <div className="flex items-center justify-between px-[16px] py-[10px] rounded-t-[8px] border-b border-[#EBEBEB] bg-[#F1F7FE]">
                <p className="text-16 font-semibold">
                  {
                    BUSINESS_DAYS_NAME_MAP[businessDay?.day?.toLowerCase()]
                      ?.longName
                  }
                </p>
                <div className="flex items-center">
                  <div
                    className="rista-sprite ic-pencil-grey cursor-pointer mr-[18px]"
                    onClick={() =>
                      onTimeSlotEditIconClick(
                        businessDay?.day,
                        businessDay?.slots
                      )
                    }
                  ></div>
                  <div
                    className="rista-sprite ic-delete-grey cursor-pointer"
                    onClick={() => onTimeSlotDeleteIconClick(businessDay?.day)}
                  ></div>
                </div>
              </div>
              <div className="px-[16px] py-[14px]">
                {businessDay?.slots?.length
                  ? businessDay?.slots.map((slot: any, index: number) => {
                      return (
                        <span
                          key={`timelines-${index}`}
                          className="min-w-fit text-16 font-normal leading-none"
                        >{`${index > 0 ? ", " : ""}${tConvert(
                          slot?.startTime
                        )} - ${tConvert(slot?.endTime, true)}`}</span>
                      );
                    })
                  : null}
              </div>
            </div>
          ) : null;
        })
      : null;
  }

  return (
    <Modal open={true} onClose={onModalClose}>
      <div
        className={`delivery-timings-modal absolute bg-white w-[636px] h-[668px] rounded-[8px]
        overflow-hidden left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 pt-[70px]  pb-[76px]
        sm:left-0 sm:right-0 sm:bottom-0 sm:top-auto sm:translate-x-0 sm:translate-y-0
        sm:w-full sm:min-h-[40%] sm:h-[90%] sm:rounded-b-[0]
      `}
      >
        {renderModalHeader()}
        {apiErrorMsg?.show ? (
          renderJsonErrorMessage(apiErrorMsg?.message)
        ) : (
          <>
            <div className="px-[24px] pt-[20px] pb-[10px] max-h-full overflow-y-auto sm:px-[16px]">
              {renderDeliveryTimeSlots()}
            </div>
            {renderActionFooter()}
          </>
        )}
        {timeSlotEditModalData.show && (
          <TimelineManagementModal
            daySelected={timeSlotEditModalData?.day}
            isTimelineEditMode={timeSlotEditModalData?.isEditMode}
            curDayTimeSlots={timeSlotEditModalData?.slots}
            onModalClose={onTimeSlotEditModalClose}
            onSaveCtaClick={onTimeSlotEditModalSave}
            tConvert={tConvert}
          />
        )}
      </div>
    </Modal>
  );
};

export default DeliveryTimings;
